import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from 'assets/icons/check-circle-dark-v2.svg?react';
import CircleDisabledIcon from 'assets/icons/circle-no-check-disabled.svg?react';
import CircleIcon from 'assets/icons/circle-no-check.svg?react';
import classes from 'classnames';
import styles from './Breadcrumb.module.scss';

export type Props = {
  currentStep?: number;
  pendingSteps?: number[];
};

const Breadcrumb = ({ currentStep = 1, pendingSteps = [] }: Props) => {
  const { t } = useTranslation('active_loan_debt_restructuring');
  const steps = t('offerSteps', { returnObjects: true }) as string[];
  return (
    <div className={styles.wrapper} data-test="breadcrumb-wrapper">
      {Object.values(steps).map((step, index) => {
        const stepIndex = index + 1;

        const stepsPassed = stepIndex < currentStep;
        const isCurrentStep = stepIndex === currentStep;
        const isStepDisabled = stepIndex > currentStep;

        const iconEnabled =
          stepsPassed && !pendingSteps.includes(stepIndex) ? (
            <CheckIcon data-test="breadcrumb-checkIcon" />
          ) : (
            <CircleIcon data-test="breadcrumb-circleIcon" />
          );

        return (
          <div
            className={classes(
              styles.point,
              (stepsPassed || isCurrentStep) && styles.enabled,
              isCurrentStep && styles.active,
              isStepDisabled && styles.disabled,
            )}
            data-test={`breadcrumb-step-${stepIndex}`}
          >
            {stepsPassed || isCurrentStep ? (
              iconEnabled
            ) : (
              <CircleDisabledIcon data-test="breadcrumb-circleDisabledIcon" />
            )}
            <div data-test={`breadcrumb-step-text-${stepIndex}`}>{step}</div>
          </div>
        );
      })}
      <div
        className={styles['point-separator']}
        data-test="breadcrumb-separator"
      ></div>
    </div>
  );
};

export default memo(Breadcrumb);
